import React, { Component } from "react";
import ReactGridLayout from "react-grid-layout";
import Gallery from "react-photo-gallery";
import moment from "moment";
import pick from "lodash/pick";
import findIndex from "lodash/findIndex";
import { Countdown } from "./components/Clocks/Countdown";
import { WaveGallery } from "./components/Galleries/WaveGallery";
import { PolaroidGallery } from "./components/Galleries/PolaroidGallery";
import { PolaroidWithPinGallery } from "./components/Galleries/PolaroidWithPinGallery";
import { PureVerticalTimeline } from "./components/Notifications/NotificationVerticalTimeline";
import { NewsTimeline } from "./components/News/NewsTimeline";
import { NewsFullBackgroundCard } from "./components/News/NewsFullBackgroundCard";
import { NewsHorizontalCard } from "./components/News/NewsHorizontalCard";
import { NewsGradientCard } from "./components/News/NewsGradientCard";
import { NewsWhiteCard } from "./components/News/NewsWhiteCard";
import { NewsDiagonalCard } from "./components/News/NewsDiagonalCard";
import { NewsTransparentBottomBackgroundCard } from "./components/News/NewsTransparentBottomBackgroundCard";
import { NewsSlider } from "./components/News/NewsSlider";
import { Tweets } from "./components/Tweets";
import AnalogClock, { Themes } from "react-analog-clock";
import connectNews from "./connectors/newsConnector";
import connectPhotos from "./connectors/photosConnector";
import connectTweets from "./connectors/tweetsConnector";
import connectNotifications from "./connectors/notificationsConnector";
import { Header, Button, Dropdown, Menu, Segment, Icon, Input, Checkbox } from "semantic-ui-react";
import { isValidColor, formatField } from "./utils";
import Grid from "./utils/grid";
import ColorPicker from "rc-color-picker";
import DatePicker from "react-datepicker";
import Slider from 'react-rangeslider'
import Dropzone from 'react-dropzone'
import UnsplashPicker from './components/UnsplashPicker'
import Collapsible from 'react-collapsible';
import "react-datepicker/dist/react-datepicker.css";
import "rc-color-picker/assets/index.css";
import "./App.css";
import "../node_modules/react-grid-layout/css/styles.css";
import "../node_modules/react-resizable/css/styles.css";
import 'react-rangeslider/lib/index.css'

const Center = ({ children }) => (
  <div style={{ display: "table", width: "100%", height: "100%" }}>
    <div
      style={{
        display: "table-cell",
        verticalAlign: "middle",
        textAlign: "center"
      }}
    >
      {children}
    </div>
  </div>
);

const handleDropRejected = (...args) => console.log('reject', args)

const layoutWidth = 1920;
const layoutHeight = 1080;
const gridScale = 0.8;
let nextId = 100;

const ConnectedWaveGallery = connectPhotos(WaveGallery);
const ConnectedResponsiveGallery = connectPhotos(Gallery);
const ConnectedPolaroidGallery = connectPhotos(PolaroidGallery, {
  reverse: true,
  animate: true,
  startCount: 5
});
const ConnectedPolaroidWithPinGallery = connectPhotos(PolaroidWithPinGallery);
const ConnectedNewsDiagonalCard = connectNews(NewsDiagonalCard);
const ConnectedNewsWhiteCard = connectNews(NewsWhiteCard);
const ConnectedNewsGradientCard = connectNews(NewsGradientCard);
const ConnectedNewsTransparentCard = connectNews(NewsTransparentBottomBackgroundCard);
const ConnectedNewsFullBackgroundCard = connectNews(NewsFullBackgroundCard);
const ConnectedNewsHorizontalCard = connectNews(NewsHorizontalCard);
const ConnectedNewsTimeline = connectNews(NewsTimeline);
const ConnectedNewsSlider = connectNews(NewsSlider);

const ConnectedNotifications = connectNotifications(PureVerticalTimeline);
const ConnectedTweets = connectTweets(Tweets);

const socialComponentsInfo = {
  news_white_card: {
    value: "Sample Card",
    image: require("./assets/news-white-card.png"),
    fields: [{ name: "rssFeed", type: "text" }, { name: "Supprimer", type: "delete" }],
    defaultProps: {
      rssFeed: "https://www.melty.fr/actu.rss"
    }
  },
  news_diagonal_card: {
    value: "Diagonal Card",
    image: require("./assets/news-diagonal-card.png"),
    fields: [{ name: "rssFeed", type: "text" }, { name: "Supprimer", type: "delete" }],
    defaultProps: {
      rssFeed: "https://www.melty.fr/actu.rss"
    }
  },
  news_gradient_card: {
    value: "Gradient Card",
    image: require("./assets/news-gradient-card.png"),
    fields: [{ name: "rssFeed", type: "text" }, { name: "Supprimer", type: "delete" }],
    defaultProps: {
      rssFeed: "https://www.melty.fr/actu.rss"
    }
  },
  news_transparent_card: {
    value: "Blurred Card",
    image: require("./assets/news-transparent-bottom-card.png"),
    fields: [{ name: "rssFeed", type: "text" }, { name: "Supprimer", type: "delete" }],
    defaultProps: {
      rssFeed: "https://www.melty.fr/actu.rss"
    }
  },
  news_full_background_card: {
    value: "Background Card",
    image: require("./assets/news-full-background-card.png"),
    fields: [{ name: "rssFeed", type: "text" }, { name: "Supprimer", type: "delete" }],
    defaultProps: {
      rssFeed: "https://www.melty.fr/actu.rss"
    }
  },
  news_horizontal_card: {
    value: "Horizontal Card",
    image: require("./assets/news-horizontal-card.png"),
    fields: [{ name: "rssFeed", type: "text" }, { name: "Supprimer", type: "delete" }],
    defaultProps: {
      rssFeed: "https://www.melty.fr/actu.rss"
    }
  },
  news_slider: {
    value: "Slider",
    image: require("./assets/news-slider.png"),
    fields: [{ name: "rssFeed", type: "text" }, { name: "Supprimer", type: "delete" }],
    defaultProps: {
      rssFeed: "https://www.melty.fr/actu.rss"
    }
  },
  news_timeline: {
    value: "Timeline",
    image: require("./assets/notifications.png"),
    defaultProps: {
      position: "left",
      rssFeed: "https://www.melty.fr/actu.rss"
    },
    fields: [
      { name: "rssFeed", type: "text" },
      {
        name: "position",
        type: "select-timeline",
        options: ["center", "left", "right"]
      },
      { name: "Supprimer", type: "delete" }
    ]
  },
  gallery_responsive: {
    value: "Responsive",
    image: require("./assets/gallery-responsive.png"),
    fields: [{ name: "Supprimer", type: "delete" }]
  },
  gallery_wave: {
    value: "Wave",
    image: require("./assets/gallery-wave.png"),
    fields: [{ name: "Supprimer", type: "delete" }]
  },
  gallery_polaroid: {
    value: "Polaroid",
    image: require("./assets/gallery-polaroid.png"),
    fields: [{ name: "Supprimer", type: "delete" }]
  },
  gallery_polaroid_with_pin: {
    value: "Polaroid with Pin",
    image: require("./assets/gallery-polaroid-with-pin.png"),
    fields: [{ name: "Supprimer", type: "delete" }]
  },
  times_clock: {
    value: "Clock",
    image: require("./assets/clock.png"),
    defaultProps: {
      theme: "dark"
    },
    fields: [
      {
        name: "theme",
        type: "select",
        options: ["dark", "light", "aqua", "lime", "sherbert", "navy"]
      },
      { name: "Supprimer", type: "delete" }
    ]
  },
  times_countdown: {
    value: "Countdown",
    image: require("./assets/countdown.png"),
    fields: [{ name: "Date", type: "datepicker" }, { name: "Supprimer", type: "delete" }]
  },
  others_notifications: {
    value: "Notifications",
    image: require("./assets/notifications.png"),
    defaultProps: {
      position: "left"
    },
    fields: [
      {
        name: "position",
        type: "select-timeline",
        options: ["center", "left", "right"]
      },
      { name: "Supprimer", type: "delete" }
    ]
  },
  others_tweets: {
    value: "Tweets",
    image: require("./assets/tweets.png"),
    fields: [{ name: "Supprimer", type: "delete" }]
  }
};

class ColorComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      pickerColor: this.props.colorCode
    };
  }

  render() {
    const { colorCode, title, onChange, onChangeComplete } = this.props;
    const isValid = isValidColor(colorCode);

    return (
      <div style={{ paddingBottom: 4, width: 160 }}>
        <div style={{}}>
          <div className="colorText">{title}</div>
          <div className={"ui mini right labeled input " + (isValid ? "" : "error")}>
            <input
              type="text"
              value={colorCode}
              style={{ width: 70, height: "13px" }}
              onChange={e => onChange(e.target.value)}
            />
            <ColorPicker
              animation="slide-up"
              color={colorCode}
              className="colorPickerSize"
              onChange={colors => {
                this.setState({ pickerColor: colors.color });
                onChangeComplete(colors.color);
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}

class SocialComponentInfos extends Component {
  render() {
    const { infos, onClick } = this.props;

    return (
      <div>
        {Object.keys(infos).map((type, i) => (
          <div
            className="screen-template screen-template--square"
            key={i}
            onClick={() => onClick(type, infos[type].defaultProps)}
          >
            <div className="screen-template__border">
              <div className="screen-template__image" style={{ backgroundImage: `url(${infos[type].image})` }} />
            </div>
            <div className="screen-template__label">{infos[type].value}</div>
          </div>
        ))}
      </div>
    );
  }
}

class SocialComponent extends Component {
  render() {
    const { w, h, unitWidth, unitHeight, primaryColor, secondaryColor, dueDate, position } = this.props;
    const containerWidth = w * unitWidth;
    const containerHeight = h * unitHeight;
    switch (this.props.type) {
      case "gallery_wave": {
        return (
          <ConnectedWaveGallery
            key={w + "-" + h}
            rows={h}
            cols={w}
            colSize={unitWidth}
            rowSize={unitHeight}
            width={unitWidth * w}
          />
        );
      }
      case "gallery_responsive": {
        return <ConnectedResponsiveGallery columns={Math.floor(w / 2)} />;
      }
      case "gallery_polaroid": {
        const imageWidth = containerWidth - 650;
        return (
          <ConnectedPolaroidGallery
            imageWidth={imageWidth}
            top={containerHeight / 5}
            imageHeight={containerHeight - 160}
          />
        );
      }
      case "gallery_polaroid_with_pin": {
        return <ConnectedPolaroidWithPinGallery />;
      }
      case "news_diagonal_card": {
        const newsCount = Math.floor(w / 2);
        const newsWidth = (containerWidth - 10 * newsCount) / newsCount;
        const { rssFeed } = this.props;
        return (
          <ConnectedNewsDiagonalCard
            newsNumber={newsCount}
            primaryColor={primaryColor}
            secondaryColor={secondaryColor}
            containerWidth={newsWidth}
            containerHeight={containerHeight - 20}
            rssFeed={rssFeed}
          />
        );
      }
      case "news_gradient_card": {
        const newsCount = Math.floor(w / 2);
        const newsWidth = (containerWidth - 10 * newsCount) / newsCount;
        const { rssFeed } = this.props;
        return (
          <ConnectedNewsGradientCard
            newsNumber={newsCount}
            primaryColor={primaryColor}
            secondaryColor={secondaryColor}
            containerWidth={newsWidth}
            containerHeight={containerHeight - 20}
            rssFeed={rssFeed}
          />
        );
      }
      case "news_transparent_card": {
        const newsCount = Math.floor(w / 2);
        const newsWidth = (containerWidth - 10 * newsCount) / newsCount;
        const { rssFeed } = this.props;
        return (
          <ConnectedNewsTransparentCard
            newsNumber={newsCount}
            primaryColor={primaryColor}
            secondaryColor={secondaryColor}
            containerWidth={newsWidth}
            containerHeight={containerHeight - 20}
            rssFeed={rssFeed}
          />
        );
      }
      case "news_white_card": {
        const newsCount = Math.floor(w / 2);
        const newsWidth = (containerWidth - 10 * newsCount) / newsCount;
        const { rssFeed } = this.props;
        return (
          <ConnectedNewsWhiteCard
            newsNumber={newsCount}
            primaryColor={primaryColor}
            secondaryColor={secondaryColor}
            containerWidth={newsWidth}
            containerHeight={containerHeight - 20}
            rssFeed={rssFeed}
          />
        );
      }
      case "news_full_background_card": {
        const newsCount = Math.floor(w / 2);
        const newsWidth = (containerWidth - 10 * newsCount) / newsCount;
        const { rssFeed } = this.props;
        return (
          <ConnectedNewsFullBackgroundCard
            newsNumber={newsCount}
            primaryColor={primaryColor}
            secondaryColor={secondaryColor}
            containerWidth={newsWidth}
            containerHeight={containerHeight - 20}
            rssFeed={rssFeed}
          />
        );
      }
      case "news_horizontal_card": {
        const newsCount = Math.floor(h / 2);
        const { rssFeed } = this.props;
        return (
          <ConnectedNewsHorizontalCard
            primaryColor={primaryColor}
            containerHeight={containerHeight / newsCount - 15 * (1 + 1 / newsCount)}
            rssFeed={rssFeed}
          />
        );
      }
      case "news_slider": {
        const newsCount = Math.floor(containerHeight / 75);
        const { rssFeed } = this.props;
        return (
          <ConnectedNewsSlider
            primaryColor={primaryColor}
            secondaryColor={secondaryColor}
            newsNumber={newsCount}
            rssFeed={rssFeed}
          />
        );
      }
      case "news_timeline": {
        const { rssFeed } = this.props;
        return <ConnectedNewsTimeline primaryColor={primaryColor} position={position} rssFeed={rssFeed} />;
      }
      case "times_clock": {
        const widthClock = Math.min(containerWidth, containerHeight);
        return (
          <Center>
            <div style={{ width: widthClock, margin: "0 auto" }}>
              <AnalogClock theme={Themes[this.props.theme]} width={widthClock * 0.9} />
            </div>
          </Center>
        );
      }
      case "times_countdown": {
        return (
          <Center>
            <Countdown date={dueDate} primaryColor={primaryColor} />
          </Center>
        );
      }
      case "others_notifications": {
        return <ConnectedNotifications primaryColor={primaryColor} position={position} />;
      }
      case "others_tweets": {
        const { hashtag } = this.props;
        return <ConnectedTweets key={hashtag} hashtag={hashtag} />;
      }
    }
  }
}

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      layout: [],
      preview: null,
      selectedIndex: null,
      displayHeader : false, 
      socialwallTitle : '',
      socialwallSlogan : '',
      backgroundImage: '', 
      brightnessValue: 100,
      position: '',
      dueDate: moment().add(1, "days"),
      activeItem: "News",
      primaryColor: "#4C2CBF",
      secondaryColor: "#DB6565",
      headerColor: ''
    };
  }

  handleDrop = ([{ preview }]) => {
    this.setState({ preview })
  }

  updateItem = layoutItem => {
    function pickLayout(item) {
      return pick(item, ["w", "h", "x", "y"]);
    }
    this.setState({
      layout: this.state.layout.map(item => {
        if (item.i !== layoutItem.i) return item;
        return { ...item, ...pickLayout(layoutItem) };
      })
    });
  };

  onResize = (layout, oldLayoutItem, layoutItem, placeholder) => {
    this.updateItem(layoutItem);
  };

  onResizeStop = (layout, oldLayoutItem, layoutItem, placeholder) => {
    this.updateItem(layoutItem);
  };

  onLayoutChange = layout => {};

  isGridContainsComponent = name => {
    const { layout } = this.state;
    const components = layout.findIndex(item => item.i.includes(name));
    return components !== -1;
  };

  createItem(type, defaultProps) {
    const { layout } = this.state;
    let grid = new Grid(12, 8);

    if (type.includes("news")) {
      const coordinates = grid.findEmptySpaceInsideGrid(layout, 6, 4);
      return {
        i: type + "-" + nextId++,
        type,
        x: coordinates.x,
        y: coordinates.y,
        w: 6,
        h: 4,
        minW: 4,
        minH: 4,
        ...defaultProps
      };
    } else if (type.includes("clock")) {
      const coordinates = grid.findEmptySpaceInsideGrid(layout, 2, 2);
      return {
        i: type + "-" + nextId++,
        type,
        x: coordinates.x,
        y: coordinates.y,
        w: 2,
        h: 2,
        minW: 2,
        maxW: 3,
        minH: 2,
        maxH: 3,
        ...defaultProps
      };
    } else if (type.includes("countdown")) {
      const coordinates = grid.findEmptySpaceInsideGrid(layout, 3, 1);
      return {
        i: type + "-" + nextId++,
        type,
        x: coordinates.x,
        y: coordinates.y,
        w: 3,
        h: 1,
        minW: 3,
        maxW: 3,
        minH: 1,
        maxH: 2,
        ...defaultProps
      };
    } else if (type.includes("tweets")) {
      const coordinates = grid.findEmptySpaceInsideGrid(layout, 6, 4);
      return {
        i: type + "-" + nextId++,
        type,
        x: coordinates.x,
        y: coordinates.y,
        w: 6,
        h: 4,
        minH: 4,
        maxH: 8,
        ...defaultProps
      };
    } else if (type.includes("gallery")) {
      const coordinates = grid.findEmptySpaceInsideGrid(layout, 6, 4);
      return {
        i: type + "-" + nextId++,
        type,
        x: coordinates.x,
        y: coordinates.y,
        w: 6,
        h: 4,
        minW: 6,
        minH: 4,
        ...defaultProps
      };
    } else if (type.includes("notifications")) {
      const coordinates = grid.findEmptySpaceInsideGrid(layout, 6, 3);
      return {
        i: type + "-" + nextId++,
        type,
        x: coordinates.x,
        y: coordinates.y,
        w: 6,
        h: 5,
        minW: 6,
        minH: 4,
        ...defaultProps
      };
    } else
      return {
        i: type + "-" + nextId++,
        type,
        x: 0,
        y: 0,
        w: 4,
        h: 2,
        minW: 2,
        minH: 4,
        ...defaultProps
      };
  }

  handleSelect = (layout, oldLayoutItem, layoutItem, placeholder) => {
    const selectedIndex = findIndex(layout, item => item.i === layoutItem.i);
    if (selectedIndex !== this.state.selectedIndex) {
      this.setState({ selectedIndex });
    }
  };

  handleAddComponent = (type, defaultProps = {}) => {
    try {
      const newGridItem = this.createItem(type, defaultProps);
      this.setState({
        layout: [...this.state.layout, newGridItem]
      });
    } catch (e) {
      alert("/!\\ You can't add this component ! There is no more space in the grid ", type);
    }
  };

  handleOptionChange = (key, value) => {
    const { selectedIndex } = this.state;
    const layout = this.state.layout.slice(0);
    layout[selectedIndex] = {
      ...layout[selectedIndex],
      [key]: value
    };
    this.setState({ layout });
  };

  handleChangePrimaryColor = color => {
    this.setState({ primaryColor: color });
  };

  handleChangeSecondaryColor = color => {
    this.setState({ secondaryColor: color });
  };

  handleChangeHeaderColor = color => {
    this.setState({ headerColor: color });
  };

  handleTabComponentsClick = (e, { name }) => {
    this.setState({ activeItem: name });
  };

  handleDateChange = date => {
    this.setState({ dueDate: date });
  };

  handleChangePositionTimeline = position => {
    this.setState({ position });
  };

  handleRemoveComponent = (value, name) => {
    const { layout } = this.state;

    if (window.confirm("Voulez-vous vraiment supprimer ce composant « " + name + " » ?")) {
      const newLayout = layout.filter(item => item.i !== layout[value].i);
      this.setState({ layout: newLayout });
      this.setState({ selectedIndex: null });
    }
  };

  handleChangeBackgroundImage = (photo) =>{
    this.setState({backgroundImage: photo.uri})
  }

  handleUpdateBackgroundColor = (event) => {
    event.persist(); 
    this.setState({backgroundImage : event.target.value});
  }

  handleChangeBackgroundBrightnessFilter = (value) => {
    this.setState({brightnessValue: value})
  }

  handleDisplayHeader = (checked) => {
    this.setState({displayHeader: !this.state.displayHeader})
  }

  handleUpdateTitle = (event) => {
    event.persist(); 
    this.setState({socialwallTitle : event.target.value});
  }

  handleUpdateSlogan = (event) => {
    event.persist(); 
    this.setState({socialwallSlogan : event.target.value});
  }

  getComponentsByType(type) {
    let object = {};
    Object.keys(socialComponentsInfo)
      .filter(item => item.includes(type))
      .forEach(function(key) {
        object = { ...object, [key]: socialComponentsInfo[key] };
      });
    return object;
  }

  renderComponents = () => {
    const { activeItem } = this.state;
    if (activeItem === "News") return this.getComponentsByType("news");
    else if (activeItem === "Galeries") return this.getComponentsByType("gallery");
    else if (activeItem === "Heure") return this.getComponentsByType("times");
    else if (activeItem === "Autres") return this.getComponentsByType("others");
  };

  renderEditor() {
    const { selectedIndex } = this.state;

    if (selectedIndex === null) return null;

    const selected = this.state.layout[selectedIndex];
    const { type } = selected;
    const info = socialComponentsInfo[type] || {};
    const fields = info.fields || [];
    return (
      <div>
        <Collapsible trigger="OPTIONS">
          {fields.map(field => {
            switch (field.type) {
              case "text":
                return (
                  <div style={{ marginBottom: 4 }}>
                    <Input
                      key={field.name}
                      label={field.name}
                      name={field.name}
                      value={selected[field.name]}
                      labelPosition="left"
                      color="red"
                      onChange={(e, { name, value }) => this.handleOptionChange(field.name, value)}
                    />
                  </div>
                );
              case "delete":
                return (
                  <Button
                    key={field.name}
                    icon
                    labelPosition="left"
                    color="red"
                    onClick={() => this.handleRemoveComponent(selectedIndex, formatField(type))}
                  >
                    <Icon name="trash outline" />
                    Supprimer
                  </Button>
                );

              case "select":
                return (
                  <div style={{ marginBottom: 15 }}>
                    <Dropdown key={field.name} text="Theme" icon="paint brush" floating labeled button className="icon">
                      <Dropdown.Menu>
                        {field.options.map((o, i) => (
                          <Dropdown.Item key={o} value={o} onClick={() => this.handleOptionChange(field.name, o)}>
                            {o}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                );

              case "select-timeline":
                return (
                  <Dropdown key={field.name} text="Position" floating labeled button className="icon">
                    <Dropdown.Menu>
                      {field.options.map((o, i) => (
                        <Dropdown.Item 
                          key={o} 
                          value={o} 
                          onClick={() => this.handleChangePositionTimeline(o)}>
                            <Icon name={`align ${o}`} />
                            {o.toUpperCase()}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                );

              case "datepicker":
                return (
                  <div key={field.name} className="countdown-datepicker">
                    <div className="colorText">{field.name}</div>
                    <DatePicker
                      selected={this.state.dueDate}
                      onChange={this.handleDateChange}
                      showTimeSelect
                      timeFormat="HH:mm"
                      timeIntervals={60}
                      dateFormat="LLL"
                      timeCaption="time"
                    />
                  </div>
                );
              default: {
                console.warn("Unhandled field type", field.type);
              }
            }
          })}
        </Collapsible>
      </div>
    );
  }

  render() {
    const { layout, 
            primaryColor,
            secondaryColor, 
            headerColor,
            socialwallTitle, 
            socialwallSlogan, 
            brightnessValue, 
            displayHeader, 
            preview, 
            backgroundImage, 
            activeItem, 
            dueDate, 
            position, 
            selectedIndex 
          } = this.state;

    const unitWidth = layoutWidth / 12;
    const unitHeight = displayHeader ? (layoutHeight-120) / 8 : layoutHeight/8
    const infos = this.renderComponents();

    return (
      <div className="App">
        <div style={{ display: "table", width: "100%" }}>
          <div
            style={{
              display: "table-cell",
              width: 1540,
              maxWidth: 1540,
              overflow: "hidden",
              verticalAlign: "top"
            }}
          >
            <div style={{ height: 865, maxHeight: 865 }}>
              <div
                style={{
                  transformOrigin: "0 0",
                  transform: `scale(${gridScale})`,
                  width: layoutWidth,
                  height: layoutHeight,
                  backgroundColor: "#EEE",
                  border: "1px solid #DDD"
                }}
              >
              <div style={{
                  position:'absolute', 
                  top:0, 
                  left:0, 
                  right:0, 
                  bottom:0,
                  backgroundImage: `url(${backgroundImage})`,
                  filter: `brightness(${brightnessValue}%)`,
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'center',
                  backgroundSize:'cover', 
                  zIndex:-1
                }}>
              </div>
              { displayHeader && 
                <div style={{
                        height: 120, 
                        width:'100%',
                        borderBottom:'#bbb 3px solid', 
                        backgroundColor:headerColor
                  }}>
                  <div className="headerLogo">
                    {preview && 
                      <img src={preview} alt='logo' 
                          style={{ maxHeight: 110}}
                      />}
                  </div>
                  <div className='headerTitle'>
                      <h1 class='socialwallTitle'>{socialwallTitle}</h1>
                  </div>
                  <div className='headerSlogan'>
                      <h1 class='socialwallSlogan'>{socialwallSlogan}</h1>
                  </div>

                </div>
              }
                <ReactGridLayout
                  className="layout"
                  layout={layout}
                  margin={[0, 0]}
                  cols={12}
                  onResize={this.onResize}
                  onDragStart={this.handleSelect}
                  onResizeStart={this.handleSelect}
                  onResizeStop={this.onResizeStop}
                  onLayoutChange={this.onLayoutChange}
                  compactType={null}
                  rowHeight={unitHeight}
                  autoSize={false}
                  width={layoutWidth}
                  style={{ filter: `brightness(100%)`, width: layoutWidth, height: layoutHeight }}
                >
                  {layout.map((item, i) => (
                    <div
                      key={item.i}
                      className="gridItem"
                      style={{
                        boxShadow: `inset ${i === selectedIndex ? "0px 0px 0px 4px #f00" : "0px 0px 0px 1px #000"}`
                      }}
                    >
                      <SocialComponent
                        {...item}
                        primaryColor={primaryColor}
                        secondaryColor={secondaryColor}
                        unitWidth={unitWidth}
                        unitHeight={unitHeight}
                        dueDate={dueDate}
                        position={position}
                        hashtag={"#LeMeilleurPatissier"}
                      />
                    </div>
                  ))}
                </ReactGridLayout>
              </div>
            </div>
          </div>

          <div
            style={{
              display: "table-cell",
              verticalAlign: "top",
              backgroundColor: "#fff"
            }}
          >
            <div className="componentsTab">
              <h2 className="editorTitle" style={{ marginBottom: "20px", textAlign: "center" }}>
                Composants
              </h2>

              <Menu attached="top" tabular>
                <Menu.Item name="News" active={activeItem === "News"} onClick={this.handleTabComponentsClick} />
                <Menu.Item
                  name="Galeries"
                  active={activeItem === "Galleries"}
                  onClick={this.handleTabComponentsClick}
                />
                <Menu.Item name="Heure" active={activeItem === "Heure"} onClick={this.handleTabComponentsClick} />
                <Menu.Item name="Autres" active={activeItem === "Autres"} onClick={this.handleTabComponentsClick} />
              </Menu>
              <Segment attached="bottom">
                <SocialComponentInfos infos={infos} title={activeItem} onClick={this.handleAddComponent} />
              </Segment>
            </div>

            <div style={{ marginTop: "15px" }} className="editorCustomisation">
              <h2 className="editorTitle" style={{ marginBottom: "20px" }}>
                Customisation
              </h2>
              <div style={{marginTop:10, marginBottom:10}}>
              <Collapsible trigger="COULEURS" open={true}>
              <div style={{ display: 'flex', flexDirection: "row" }}>
                <ColorComponent
                  title={"Primary"}
                  colorCode={primaryColor}
                  onChange={this.handleChangePrimaryColor}
                  onChangeComplete={this.handleChangePrimaryColor}
                />
                <ColorComponent
                  title={"Secondary"}
                  colorCode={secondaryColor}
                  onChange={this.handleChangeSecondaryColor}
                  onChangeComplete={this.handleChangeSecondaryColor}
                />
               
              </div>
              
              </Collapsible>
              <Collapsible trigger="IMAGE DE FOND">
              <div style={{ marginBottom: 4 }}>
                    <Input
                      label={'URL'}
                      value={backgroundImage}
                      labelPosition="left"
                      color="red"
                      onChange={this.handleUpdateBackgroundColor}
                    />
                  </div>
                    <UnsplashPicker onSelect={photo=>this.handleChangeBackgroundImage(photo)} />
                    <div style={{marginRight:60}}>
                    <p style={{fontFamily:'Raleway', fontWeight:'bold', marginBottom:-5, marginTop:10}}>Luminosité : </p>
                    <Slider
                      min={0}
                      max={100}
                      step={1}
                      handleLabel=''
                      value={brightnessValue}
                      onChange={this.handleChangeBackgroundBrightnessFilter}
                    />
                    </div>
              </Collapsible>

              <Collapsible trigger="HEADER">
                <Checkbox slider label='Afficher un header' className="displayHeaderText"  
                        onChange={(evt, { checked }) => this.handleDisplayHeader(checked)} /> 
                {displayHeader && 
                  <div style={{ marginTop:10 }}>
                  <Dropzone 
                    onDrop={ this.handleDrop }
                    style={{
                      cursor:'pointer',
                      height:'auto',
                      padding:10, 
                      fontFamily:'Raleway',
                      width:224,
                      backgroundColor:'#e8e8e8',
                      border:'dashed 1px #000',
                      marginBottom:10
                    }}
                    accept="image/jpeg,image/jpg,image/tiff,image/png,image/gif" 
                    multiple={ false } 
                    onDropRejected={ handleDropRejected }>
                      Glisser / uploader un logo 
                  </Dropzone>
                  <Input
                    label={'TITRE'}
                    value={socialwallTitle}
                    labelPosition="left"
                    onChange={this.handleUpdateTitle}
                  />
                  <Input
                    style={{marginTop:10, marginBottom:10}}
                    label={'SLOGAN'}
                    value={socialwallSlogan}
                    labelPosition="left"
                    onChange={this.handleUpdateSlogan}
                  />
                  <ColorComponent
                  title={"Couleur"}
                  colorCode={headerColor}
                  onChange={this.handleChangeHeaderColor}
                  onChangeComplete={this.handleChangeHeaderColor}
                />
                </div>
                }        
              </Collapsible>
              {this.renderEditor()}
              </div>

              
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js